import React, { useEffect } from 'react';
import people from '../../assets/images/people.png';
import ellipse2 from '../../assets/images/ellipse2.png';
import ellipse3 from '../../assets/images/ellipse3.png';
import user4 from '../../assets/images/user4.png';
import user5 from '../../assets/images/user5.png';
import dots_rect from '../../assets/images/dots_rect.png';
import squares from '../../assets/images/squares.png';
import team1 from '../../assets/images/team1.png';
import team2 from '../../assets/images/team2.png';
import tick from '../../assets/images/tick.png';
import rakesh_rathi from '../../assets/images/rakesh_rathi.png';
import hdfc from '../../assets/images/hdfc.png';
import briefcase1 from '../../assets/images/briefcase 1.png';
import insurance1 from '../../assets/images/insurance 1.png';
import growth from '../../assets/images/growth (1) 1.png';
import insurer from '../../assets/images/insurer.png';
import mask from '../../assets/images/Mask group.png';
import building from '../../assets/images/postmodern-office-buildings-with-glass-facade 1.png';
import binacular from '../../assets/images/binoculars 1.png';
import target from '../../assets/images/target 1.png';
import { useCountUp } from 'react-countup';
import CountUp from 'react-countup';
import Tab from './Tab';
import gsap from 'gsap';

const About = () => {
  const kpiData = [
    { heading: 'Policies Sold', content: '300000+' },
    { heading: 'Corporate & SME Clients', content: '100+' },
    { heading: 'Branch Offices', content: '21+' },
    { heading: 'Online Policies Sold', content: '1500000+' },
    { heading: 'Insurance Partners', content: '35+' },
    { heading: 'Expert Professionals', content: '300+' },
  ];
  const companyArray = [
    { url: hdfc },
    { url: hdfc },
    { url: hdfc },
    { url: hdfc },
    { url: hdfc },
    { url: hdfc },
  ];
  const firstLine = 'All-in-one Solution For';
  const secondLine = 'All insurance needs';
  useEffect(() => {
    // GSAP animation for the text
    const tl = gsap.timeline();

    tl.from('.hero-text span', {
      y: -100, // Start from above
      opacity: 0,
      duration: 0.6,
      ease: 'bounce.out',
      stagger: 0.1, // Stagger the drops
    });

    const boxes = document.querySelectorAll('.inner-box');

    boxes.forEach((box, index) => {
      gsap.fromTo(
        box,
        { rotateY: 90, opacity: 0 }, // Start state
        {
          rotateY: 0, // End state
          opacity: 1,
          duration: 0.6,
          delay: index * 0.3, // Stagger effect
          ease: 'power2.out',
        }
      );
    });
    // GSAP animation for text content (popping up with fast rotation)
    gsap.from('.text-content', {
      opacity: 0,
      scale: 0.5, // Start smaller to create pop-up effect

      duration: 1.5, // Shorter duration for quicker pop-up
      stagger: 0.2, // Delay between elements
      ease: 'back.out(1.7)', // Bounce effect when popping up
      scrollTrigger: {
        trigger: '.text-content',
        start: 'top 90%', // Start when the top of the text hits 80% of the viewport
      },
    });

    // GSAP animation for image container (popping up with fast rotation)
    gsap.from('.image-container', {
      opacity: 0,
      scale: 0.5, // Start smaller to create pop-up effect

      duration: 1.5, // Shorter duration for quicker pop-up
      ease: 'back.out(1.7)', // Bounce effect when popping up
      scrollTrigger: {
        trigger: '.image-container',
        start: 'top 90%', // Start when the top of the image hits 80% of the viewport
      },
    });
  }, []);

  return (
    <div className="w-full -mt-16">
      <section
        className="relative h-[300px] md:h-[320px] lg:h-[430px] xl:h-[570px] flex justify-center items-center overflow-hidden"
        style={{
          backgroundImage: `url(${people})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black opacity-40 z-10" />
        {/* Text Container */}
        <div className="relative z-20 text-center">
          <p className="hero-text text-3xl md:text-5xl lg:text-8xl font-extrabold text-white">
            {firstLine.split('').map((char, index) => (
              <span key={index} className="inline-block">
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </p>
          <p className="hero-text text-3xl md:text-5xl lg:text-8xl font-extrabold text-white mt-2">
            {secondLine.split('').map((char, index) => (
              <span key={index} className="inline-block">
                {char === ' ' ? '\u00A0' : char}
              </span>
            ))}
          </p>
        </div>
        <img
          src={people}
          alt="Background"
          className="absolute top-0 w-full h-full object-cover z-0"
        />
      </section>
      <div className="flex justify-center items-center">
        <section className="flex flex-wrap justify-center ">
          <div className="inner-box flex flex-col  bg-white border-2 border-slate-500   p-2   transition-transform duration-500 transform hover:scale-105 w-full sm:w-1/2 md:w-1/4 h-48">
            <img
              className="icon-box  h-16 mb-2"
              src={briefcase1}
              alt="Best Prices"
            />
            <p className="icon-title font-semibold text-lg w-full">
              Best Prices
            </p>
            <p className=" text-sm  w-full pl-12">
              Access policies with the best prices in one place.
            </p>
          </div>
          <div className="inner-box flex flex-col  bg-white border-2 border-slate-500 p-2   transition-transform duration-500 transform hover:scale-105 w-full sm:w-1/2 md:w-1/4 h-48">
            <img
              className="icon-box h-16 mb-2"
              src={insurance1}
              alt="Claims Advocacy"
            />
            <p className="icon-title font-semibold text-lg w-full">
              Claims Advocacy
            </p>
            <p className="text-sm w-full pl-12">
              Our experts make the claim process hassle-free and smooth for you.
            </p>
          </div>
          <div className="inner-box flex flex-col bg-white border-2 border-slate-500 p-2 transition-transform duration-500 transform hover:scale-105 w-full sm:w-1/2 md:w-1/4 h-48">
            <img
              className="icon-box h-16 mb-2"
              src={growth}
              alt="Business Continuity Planning"
            />
            <p className="icon-title font-semibold text-lg w-full">
              Business Continuity Planning (BCP)
            </p>
            <p className="text-sm w-full pl-12">
              Keep your business running smoothly - even during unexpected
              disruptions.
            </p>
          </div>
          <div className="inner-box flex flex-col   bg-white border-2 border-slate-500 p-2 transition-transform duration-500 transform hover:scale-105 w-full sm:w-1/2 md:w-1/4 h-48">
            <img
              className="icon-box h-16 mb-2"
              src={insurer}
              alt="35+ Insurance Partners"
            />
            <p className="icon-title font-semibold text-lg w-full">
              35+ Insurance Partners
            </p>
            <p className="text-sm w-full pl-12">
              35+ Insurance Partners that help you compare easily &
              transparently.
            </p>
          </div>
        </section>
      </div>

      <section className="flex flex-col-reverse md:flex-row items-center justify-between px-4 py-8 md:py-16 md:px-12 lg:px-16 xl:px-24 space-y-8 md:space-y-0">
        <div className="w-full md:w-1/2 px-4 text-center md:text-left text-content">
          <p className="text-xl lg:text-4xl text-blue-900 font-extrabold border-l-4 lg:border-l-8 border-[#003478] pl-4 mb-4">
            Finding you the best insurance since 2015
          </p>
          <p className="text-base lg:text-lg text-gray-700 mb-4">
            Insure Efficient is more than just an insurance mediator - our team
            of experienced insurance experts provide a one-stop destination to
            compare and purchase insurance plans from across the country.
          </p>
          <p className="text-base lg:text-lg text-gray-700">
            Instantly compare and buy the best policies online for auto, health,
            travel, or life insurance from top providers like Bajaj Allianz
            General Insurance Ltd., Reliance General Insurance Ltd., and Birla
            Sun Life Insurance.
          </p>
        </div>

        <div className="relative md:w-1/2 h-[250px] md:h-[340px] rounded-2xl mx-auto image-container">
          <img
            src={mask}
            alt="Insurance Illustration"
            className="rounded-2xl object-cover w-full h-full"
          />
        </div>
      </section>
      <section className=" pr-8 flex ">
        <div>
          <img src={building} width="1000px" />
        </div>
        <div>
          <div className="vision-box">
            <div>
              <img width="120px" src={binacular} />
            </div>
            <div>
              <p className="vision-title">Our Vision </p>

              <p className="vision-p">
                It is our vision at insure efficient to provide optimum value to
                our customer at most competitive price
              </p>
            </div>
          </div>
          <div className="vision-box">
            <div>
              <img width="90px" src={target} />
            </div>
            <div style={{ marginLeft: '3rem' }}>
              <p className="vision-title">Our Mission </p>

              <p className="vision-p">
                Our mission is to create innovative solutions for the management
                of risks with the assistance of a well – motivated work force in
                order to enhance the financial well-being of all our customers
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="p-12 md:p-16">
        <h3 className="text-sm font-normal w-full text-[#1976D2] text-center">
          Our Clients
        </h3>
        <h3 className="text-3xl lg:text-4xl font-extrabold w-full uppercase text-center pt-4">
          Who do we serve ?
        </h3>
        <div className="my-4 flex flex-row flex-wrap gap-x-12 gap-y-6 justify-center pt-8">
          {companyArray.map((item, index) => {
            return (
              <div
                key={index.toString()}
                className="w-32 rounded-lg border-[1px] border-[#003478] px-2 py-2 m-4 flex-initial"
              >
                <img src={item.url} alt="" className="w-32 h-auto" />
              </div>
            );
          })}
        </div>
      </section> */}
      <section>
        <div className="kpi-box">
          <div className="inner-kpi ">
            <p className="kpi-val">
              <CountUp start={0} end={1000} enableScrollSpy={true} delay={6} />{' '}
              +
            </p>
            <span className="kpi-desc ">Point of Sales Person</span>
          </div>
          <div className="inner-kpi">
            <p className="kpi-val">
              <CountUp start={0} end={35} enableScrollSpy={true} delay={6} /> +
            </p>
            <span className="kpi-desc">Insurance Company </span>
          </div>
          <div className="inner-kpi">
            <p className="kpi-val">
              <CountUp start={0} end={100} enableScrollSpy={true} delay={6} /> +
            </p>
            <span className="kpi-desc">Corporate & SME Clients</span>
          </div>
          <div className="inner-kpi">
            <p className="kpi-val">
              <CountUp start={0} end={21} enableScrollSpy={true} delay={6} /> +
            </p>
            <span className="kpi-desc">Branch Offices</span>
          </div>
        </div>
      </section>
      <section>
        <Tab />
      </section>
    </div>
  );
};

export default About;
